module.exports = __webpack_public_path__ + "img/icon_search.819a701d.svg";